import React, { useState, useEffect } from 'react';
import { useParams, Navigate }         from 'react-router-dom';
import { client }                       from './SanityClient';
import JobApplication                   from './JobApplication';
import './JobPages.css';

export default function JobPage() {
  const { jobId } = useParams();
  const [job, setJob]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [showApp, setShowApp] = useState(false);      

  useEffect(() => {
    client
      .fetch(
        `*[_type == "job" && _id == $id][0]{
           title,
           description,
           location,
           specialization,
           qualifications
         }`,
        { id: jobId }
      )
      .then(doc => {
        setJob(doc);
        setLoading(false);
      })
      .catch(err => {
        console.error('Sanity fetch error:', err);
        setLoading(false);
      });
  }, [jobId]);

  if (loading) return <p>Loading…</p>;
  if (!job)    return <Navigate to="/careers" replace />;

  return (
    <div className="job-page">
      <h1 className="job-title">{job.title}</h1>
      <p className="job-location">{job.location}</p>

      {job.description && (
        <div className="job-description">
          <h2>Description</h2>
          <p>{job.description}</p>
        </div>
      )}

      <button
        className="apply-btn"
        onClick={() => setShowApp(true)}
      >
        Apply
      </button>

      {showApp && (
        <JobApplication
          jobTitle={job.title}
          onClose={() => setShowApp(false)}
        />
      )}
    </div>
  );
}
